import { InversionContainer } from '@/controller/container'
import { InjectionTokens } from '@/controller/tokens'

import { UniqueEntityID } from '@/domain/core'
import { UseCase } from '@/domain/core/UseCase'
import { Result } from '@/domain/protocols/Result'

import type { IChecklistRepository } from '@/data/ChecklistRepository/IChecklistRepository'

export class DeleteChecklistUseCase implements UseCase<UniqueEntityID | string, Promise<Result<void>>> {
  private repository: IChecklistRepository

  constructor(repository?: IChecklistRepository) {
    if (repository) {
      this.repository = repository
      return
    }
    const container = InversionContainer.getInstance().getContainer()
    this.repository = container.get<IChecklistRepository>(InjectionTokens.ChecklistRepository)
  }

  async execute(request: UniqueEntityID | string): Promise<Result<void>> {
    try {
      if (!request) return Result.fail('CHECKLIST_INVALID')

      const checklistId = request instanceof UniqueEntityID ? request : new UniqueEntityID(request)

      return await this.repository.deleteChecklist(checklistId)
    } catch (error) {
      return Result.fail(error)
    }
  }
}
